var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.saveHandler($event)}}},[_c('Breadscrumbs',{attrs:{"links":[
        {
          name: 'SubCategories',
          to: {
            name: 'SubCategories'
          }
        },
        {
          name: 'SubCategory Info',
          to: {
            name: 'SubCategoryInfo',
            params: {
              id: _vm.$route.params.id
            }
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'SubCategoryInfoEdit',
            params: {
              id: _vm.$route.params.id
            }
          }
        }
      ]}}),_c('div',{staticClass:"page-actions"},[_c('h2',[_vm._v("編輯子分類")]),_c('v-spacer'),_c('button',{staticClass:"btn mr-5",on:{"click":_vm.cancelHandler}},[_c('span',[_vm._v("取消")])]),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('span',[_vm._v("儲存")])])],1)],1),_c('SubCategoryEditCreate'),_c('LangDialog',{attrs:{"isOpen":_vm.isLangOpen},on:{"update:isOpen":function($event){_vm.isLangOpen=$event},"update:is-open":function($event){_vm.isLangOpen=$event},"confirm-submit":function($event){return _vm.saveHandler()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }